import React from 'react';
import { withTranslation } from 'react-i18next';
import {
    Message,
    CautionBoldIcon,
    Text,
    InternalGrid,
} from '@paygreen/paygreen-ui';
import { IsMobile } from '../../../utils/tools';

const NotAvailableForTestMessage = ({ t }) => (
    <Message
        colorPallet="status"
        colorStatus="danger"
        hasStaticWidth={true}
        blockWidth="md"
    >
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto 1fr"
            gridGap="sm"
            alignItems={IsMobile() ? 'flex-start' : 'center'}
        >
            <CautionBoldIcon
                colorPallet="status"
                colorStatus="danger"
                iconSize="md"
            />

            <Text
                colorPallet="status"
                colorStatus="danger"
                textSize="xs"
                data-cy="no-data-sentence"
            >
                {t('mode.noContributionMessage')}
            </Text>
        </InternalGrid>
    </Message>
);

export default withTranslation('common')(NotAvailableForTestMessage);
